<template>
<div id="app">

  <Head @getShopCode='getShopCode'></Head>
  <div class="bg-red" style="min-width:1220px">
    <div class="align-center flex-relative margin-center width" style="height: 46px;padding-left: 82px;">

      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt " style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='home'}" @click="clickOnButton('home')">首页</div>

      <!-- <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='idear'}" @click="clickOnButton('idear')">思政课程</div>-->

      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='talk'}" @click="clickOnButton('talk')">百场讲坛</div>

      <div class="padding-l-r-20 font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='special'}" @click="clickOnButton('special')">专题学习</div>
            <div class="padding-l-r-20 font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='course'}" @click="clickOnButton('course')">课程思政</div>
      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='lcountry'}" @click="clickOnButton('lcountry')">爱党爱国</div>

      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='culture'}" @click="clickOnButton('culture')">传统文化</div>

      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='redread'}" @click="clickOnButton('redread')">红色阅读</div>
      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='redfilm'}" @click="clickOnButton('redfilm')">红色电影</div>
      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='information'}" @click="clickOnButton('information')">资讯</div>
      <div class="padding-l-r-20  font-size-16 font-weight font-color-ffdada navt" style="height: 100%;line-height: 46px;cursor: pointer;" :class="{active:title=='courseDownload'}" @click="clickOnButton('courseDownload')">课件下载</div>

    </div>
  </div>

  <keep-alive v-if="$route.meta.keepAlive">
    <router-view :inputValue='inputValue'></router-view>
  </keep-alive>
  <router-view v-if="!$route.meta.keepAlive"></router-view>
</div>
</template>

<script>
export default {
  name: 'app',

  data () {
    return {
      title: 'home',
      inputValue: ''
    }
  },
  created () {

  },
  beforeUpdate () {
    this.checkTitle()
  },
  beforeMount () {
    this.checkTitle()
  },

  methods: {
    getShopCode (value) {
      // console.log(value);
      this.inputValue = value
    },
    checkTitle () {
      if (window.location.href.indexOf('/idear') != -1) {
        this.title = 'idear'
      } else if (window.location.href.indexOf('other/talk') != -1) {
        this.title = 'talk'
      } else if (window.location.href.indexOf('other/special') != -1) {
        this.title = 'special'
      } else if (window.location.href.indexOf('other/course') != -1) {
        this.title = 'course'
      } else if (window.location.href.indexOf('other/lcountry') != -1) {
        this.title = 'lcountry'
      } else if (window.location.href.indexOf('other/culture') != -1) {
        this.title = 'culture'
      } else if (window.location.href.indexOf('/redread') != -1) {
        this.title = 'redread'
      } else if (window.location.href.indexOf('/redfilm') != -1) {
        this.title = 'redfilm'
      } else if (window.location.href.indexOf('/infor') != -1) {
        this.title = 'information'
      } else {
        this.title = 'home'
      }
    },

    clickOnButton: function (des) {
      if (des == 'courseDownload') {
        window.open('http://h5.cdn.bjadks.com/website/sz-zt/Courseware/index.html')
        return
      }
      this.title = des
      this.$router.push({
        name: des
      })
    }
  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

body {
  background: #ffffff;
  padding: 0 0;
}

.active {
  color: #ffffff;
  background: #af0000;
}

.navt:hover {
  color: #ffffff;
  background: #af0000;
}
</style>



// WEBPACK FOOTER //
// src/views/homeall.vue